import React, { useState } from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import CustomBottomModal from "@Components/Modal/CustomBottomModal/CustomBottomModal"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { topicsType, followedTopics } from "@Constants/constant"
import { RFValue } from "react-native-responsive-fontsize"
import { RadioButton } from "react-native-paper"
import { Button } from "@Components/CustomButton/Button"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"

const ModalForumFilter = (props) => {
    const { toggleModal, isModalVisible, setFilters, defaultAxisId } = props
    const [selectedAxeId, setSelectedAxeId] = useState(defaultAxisId)
    const [isFavorite, setIsFavrite] = useState(0)

    const topicBgColor = (axisId) => (axisId === selectedAxeId ? baseColors.green.primary : baseColors.green.light)
    const topicLabelColor = (axisId) => (axisId === selectedAxeId ? baseColors.white : baseColors.green.primary)
    const clearFilter = () => setFilters((prev) => ({ axisId: defaultAxisId, isFavorite: false }))

    const validateFilter = () => {
        setFilters((prev) => ({ axisId: selectedAxeId, isFavorite: isFavorite }))
        toggleModal()
    }

    return (
        <CustomBottomModal toggleModal={toggleModal} open={isModalVisible}>
            <View style={styles.topicContainer}>
                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(18)}>
                    Type de sujet
                </OpenSansText>
                <View style={styles.topic}>
                    {topicsType.map((topic) => (
                        <TouchableOpacity
                            key={topic.id}
                            style={{
                                ...styles.topicLabel,
                                backgroundColor: topicBgColor(topic.id)
                            }}
                            onPress={() => setSelectedAxeId(topic.id)}
                        >
                            <OpenSansText
                                style={{ color: topicLabelColor(topic.id) }}
                                defaultFontFamily={baseFontFamily.OpenSansRegular}
                                fontSize={RFValue(16)}
                            >
                                {topic.label}
                            </OpenSansText>
                        </TouchableOpacity>
                    ))}
                </View>
            </View>

            <View style={styles.topicContainer}>
                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={RFValue(18)}>
                    Mes sujet suivi
                </OpenSansText>

                <View style={styles.radioGroupContainer}>
                    {followedTopics?.map((item) => (
                        <TouchableOpacity
                            key={item.id}
                            style={styles.radioContainer}
                            onPress={() => setIsFavrite(item.value)}
                        >
                            <View style={styles.radioContent}>
                                <RadioButton
                                    color={baseColors.green.primary}
                                    onPress={() => setIsFavrite(item.value)}
                                    status={isFavorite === item.value ? "checked" : "unchecked"}
                                />
                                <OpenSansText fontSize={RFValue(16)}>{item.label}</OpenSansText>
                            </View>
                        </TouchableOpacity>
                    ))}
                </View>
            </View>

            <Button
                onPress={validateFilter}
                text="Filtrer"
                width="70%"
                height={RFValue(50)}
                backgroundColor={baseColors.green.primary}
                labelColor={"white"}
            />

            <TouchableOpacity style={styles.clearFilter} onPress={clearFilter}>
                <OpenSansText
                    style={styles.clearFilterLabel}
                    defaultFontFamily={baseFontFamily.OpenSansBold}
                    fontSize={RFValue(16)}
                >
                    Effacer les filtres
                </OpenSansText>
            </TouchableOpacity>
        </CustomBottomModal>
    )
}

export default ModalForumFilter
